var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C5.87 0 0.5 5.37 0.5 12C0.5 17.31 3.935 21.795 8.705 23.385C9.305 23.49 9.53 23.13 9.53 22.815C9.53 22.53 9.515 21.585 9.515 20.58C6.5 21.135 5.72 19.845 5.48 19.17C5.345 18.825 4.76 17.76 4.25 17.475C3.83 17.25 3.23 16.695 4.235 16.68C5.18 16.665 5.855 17.55 6.08 17.91C7.16 19.725 8.885 19.215 9.575 18.9C9.68 18.12 9.995 17.595 10.34 17.295C7.67 16.995 4.88 15.96 4.88 11.37C4.88 10.065 5.345 8.985 6.11 8.145C5.99 7.845 5.57 6.615 6.23 4.965C6.23 4.965 7.235 4.65 9.53 6.195C10.49 5.925 11.51 5.79 12.53 5.79C13.55 5.79 14.57 5.925 15.53 6.195C17.825 4.635 18.83 4.965 18.83 4.965C19.49 6.615 19.07 7.845 18.95 8.145C19.715 8.985 20.18 10.05 20.18 11.37C20.18 15.975 17.375 16.995 14.705 17.295C15.14 17.67 15.515 18.39 15.515 19.515C15.515 21.12 15.5 22.41 15.5 22.815C15.5 23.13 15.725 23.505 16.325 23.385C18.7072 22.5807 20.7772 21.0497 22.2437 19.0074C23.7101 16.965 24.4993 14.5143 24.5 12C24.5 5.37 19.13 0 12.5 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGithub);
export default __webpack_public_path__ + "static/media/social-github.dd16060e3e4200b257cc30e38e32c463.svg";
export { ForwardRef as ReactComponent };